const $ = window.$;
let lazyLoad = function(selector, name) {
    let $mod = $(selector);
    if ($mod.length < 1) {
        return;
    }
    let winHeight = $(window).height();
    let loadImg = function() {
        let scrollTop = $(window).scrollTop() + winHeight;
        if (scrollTop + winHeight > $mod.offset().top) {
            $mod.find('.lazy-load-img').each((index, item) => {
                $(item).attr('src', $(item).data('lazy_src'));
            })

            $(window).off('scroll' + name, loadImg);
        }
    }
    $(window).on('scroll' + name, loadImg);
    loadImg();
}
module.exports = lazyLoad;



// WEBPACK FOOTER //
// ./src/assets/util/lazy-load.js